import { render } from "./Dudas.vue?vue&type=template&id=39c38f14&scoped=true"
const script = {}

import "./Dudas.vue?vue&type=style&index=0&id=39c38f14&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39c38f14"]])

export default __exports__